var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeclineCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 56,
    viewBox: "0 0 60 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#FF0000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_125_1643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5417 23.6047L17.4203 21.4834C17.2226 21.2873 17.068 21.052 16.9665 20.7927C16.8649 20.5333 16.8187 20.2557 16.8307 19.9774C16.8426 19.6992 16.9126 19.4265 17.0361 19.1768C17.1595 18.9272 17.3338 18.7061 17.5476 18.5277C19.9599 16.5882 22.7935 15.2417 25.8208 14.5962C28.6149 13.9733 31.5119 13.9733 34.3061 14.5962C37.3458 15.2458 40.1897 16.6024 42.6075 18.556C42.8207 18.7338 42.9945 18.9542 43.1179 19.2029C43.2413 19.4516 43.3116 19.7233 43.3242 20.0007C43.3369 20.2781 43.2916 20.555 43.1913 20.814C43.0911 21.0729 42.938 21.3081 42.7418 21.5046L40.6205 23.6259C40.2807 23.9725 39.8265 24.1836 39.3426 24.2201C38.8586 24.2565 38.3779 24.1157 37.9901 23.8239C37.2217 23.2346 36.3891 22.7341 35.5081 22.3319C35.1599 22.174 34.8643 21.9195 34.6562 21.5987C34.4482 21.2778 34.3365 20.9041 34.3343 20.5217V20.2499C34.3343 19.3496 33.7345 18.5471 32.8476 18.3921C31.0242 18.0732 29.1591 18.0732 27.3358 18.3921C26.4489 18.5471 25.8491 19.3496 25.8491 20.2499V20.5217C25.8469 20.9041 25.7352 21.2778 25.5272 21.5987C25.3191 21.9195 25.0235 22.174 24.6753 22.3319C23.7943 22.7341 22.9617 23.2346 22.1933 23.8239C21.8014 24.119 21.3147 24.2596 20.8257 24.2192C20.3368 24.1788 19.8798 23.9601 19.5417 23.6047Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_125_1643",
    x: 14.8288,
    y: 13.129,
    width: 30.4975,
    height: 14.097,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_125_1643"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_125_1643",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclineCall);
export default __webpack_public_path__ + "static/media/decline_call.17657483440ee3233e3e927d26a9a2ba.svg";
export { ForwardRef as ReactComponent };